export default __webpack_public_path__ + "cloud-check-sm.1186dbbd.svg";